import React from 'react'
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { useParams } from 'react-router-dom';
import WithdrawalReport from './WithdrawalReport';
import StakingReport from './StakingReport';
import { useState } from 'react';
import { GMCContext } from '../../GMCContext';
import { useEffect } from 'react';
import { useContext } from 'react';
import axios from 'axios';
import Copy from '../Common/Copy';
import LevelRewardReport from './LevelRewardReport';
import ROiOfRoiReport from './ROiOfRoiReport';
import PendingWithdrwal from './PendingWithdrwal';
// import RankRewardRepor from './RankRewardRepor';
import PoolReport from './PoolReport';
import PrimeRewardReport from './PrimeRewardReport';
import EcosystemReport from './EcosystemReport';


export default function UserReport() {
    const { formatAddress, formatDateTime } = useContext(GMCContext);
    const [data, setdata] = useState([]);
    const [totReward, setTotReward] = useState(0);
    const headerHeight = 70; // Example height of header
    const { username } = useParams();


    const getData = async () => {
        // console.log('address', username)
        await axios
            .post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "getbyid",
                key: process.env.REACT_APP_KEY,
                username: username,
            })
            .then((res) => {
                // console.log("user dash data:----------------", res.data.data)
                setdata(res.data.data);
                if (res.data.error) {
                    return "";
                }
                if (res.data.data) {
                }

            });
    };

    // console.log("data:", data)
    useEffect(() => {
        if (username) {
            getData();
        }
    }, [username]);

    return (
        <>
            <Header />
            <Sidebar />

            {/* Main Content */}
            <div
                className="main-content"
                style={{
                    marginTop: `${headerHeight}px`, // Matches header height
                    padding: '20px', // Adds padding around the content
                    minHeight: `calc(100vh - ${headerHeight}px - 50px)`, // Adjust height for footer
                    boxSizing: 'border-box', // Ensures padding is included in height
                }}
            >
                <div className="row g-3" style={{ paddingBottom: '20px', marginBottom: '30px' }}>
                    <div className="d-flex justify-content-between align-items-center">
                        {/* Left Section */}
                        <div className="flex-grow-1">
                            <h5 className="mb-50" style={{ fontSize: "2rem" }}>User Report</h5>
                        </div>

                        {/* Right Section */}
                        <div className="mt-3 mt-lg-0">
                            <form action="javascript:void(0);">
                                <div className="row g-3 mb-0 align-items-center">
                                    <div className="col-sm-auto">

                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Cards Section */}
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Re-Stake Status
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            <div className="d-flex align-items-center">
                                                {data?.restake === false ? (
                                                    <>
                                                        <div className="green-dot-active mx-2"></div>
                                                        Active
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="red-dot-active mx-2"></div>
                                                        Deactive
                                                    </>
                                                )}
                                            </div>
                                        </h4>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-2">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            User Name
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            {data?.ref_address ? (
                                                <>
                                                    <a
                                                        target="_blank"
                                                        className="text-primary"
                                                        href={`${process.env.REACT_APP_EXPLORER}/address/${data.username}`}
                                                        rel="noreferrer"
                                                    >
                                                        {(data.username)}
                                                    </a>
                                                    <Copy data={data.username} />
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </h4>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-2">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Ref.Address
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            {data?.ref_address ? (
                                                <>
                                                    <a
                                                        target="_blank"
                                                        className="text-primary"
                                                        href={`${process.env.REACT_APP_EXPLORER}/address/${data.ref_address}`}
                                                        rel="noreferrer"
                                                    >
                                                        {(data.ref_address)}
                                                    </a>
                                                    <Copy data={data.ref_address} />
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </h4>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Total Users
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            {data?.team ? data?.team : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Team Active Users
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            {data?.Active_level ? data?.Active_level : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Direct Users
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            {data?.Directs ? data?.Directs : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Team Business
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            $ {data?.teambusiness ? parseFloat(data?.teambusiness).toFixed(2) : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Total Level Reward
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            $ {data?.level_rew ? parseFloat(data?.level_rew).toFixed(2) : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Roi of Roi Reward
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            $ {data?.ror_rew ? parseFloat(data?.ror_rew).toFixed(2) : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Pool Reward
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            $ {data?.pool_rew ? parseFloat(data?.pool_rew).toFixed(2) : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Total Balance
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            $ {data?.balance ? parseFloat(data?.balance).toFixed(2) : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Staking
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            $ {data?.totalstake ? parseFloat(data?.totalstake).toFixed(2) : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Pending Withdrawal
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            $ {data?.Pending_withdraw_amt ? parseFloat(data?.Pending_withdraw_amt).toFixed(2) : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Pending Withdrawal
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            $ {data?.withdrawl ? parseFloat(data?.withdrawl).toFixed(2) : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Open Level
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            {data?.open_level ? data?.open_level : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card card-animate">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                            Withdrawal Status
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-4">
                                    <div>
                                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                            <div className="d-flex align-items-center">
                                                {data?.withdrawal_status === true ? (
                                                    <>
                                                        <div className="green-dot-active mx-2"></div>
                                                        Active
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="red-dot-active mx-2"></div>
                                                        Deactive
                                                    </>
                                                )}
                                            </div>
                                        </h4>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <StakingReport username={username} />
                    <LevelRewardReport username={username} />
                    <PoolReport username={username} />
                    <ROiOfRoiReport username={username} />
                    <PendingWithdrwal username={username} />
                    <WithdrawalReport username={username} />
                    <PrimeRewardReport username={username} />
                    <EcosystemReport username={username} />
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </>
    )
}
